import gql from "graphql-tag";
import { client, driver } from "./lib";
import { LoginForm, LoginResult, SvBook } from "./graphql";

const M_LOGIN = gql`
  mutation login($form: LoginForm) {
    login(Input: $form) {
      message
      success
      is_admin
      reader {
        reader_id
        reader_code
        reader_name
      }
    }
  }
`;

const M_LOGINPRIVATE = gql`
  mutation loginPrivate($form: LoginForm) {
    loginPrivate(Input: $form) {
      message
      success
      is_admin
      reader {
        reader_id
        reader_code
        reader_name
      }
    }
  }
`;

const QL_BOOKISBN = gql`
  query getBook($form: SVBookForm) {
    getBook(Input: $form) {
      data {
        id
        url
        title
        author
        status
        publisher
        pub_date
        edition
        price
        isbn
        photo
        intro
        locker_id
        locker_detail_id
      }
    }
  }
`;

const QL_CUSTITEM = gql`
  query getCustItem {
    getCustReserve {
      items {
        reserve_id
        hold_id
        marc_id
        title
        barcode
        callnumber
        bookdate
        vailddate
        keepdate
        bookorder
        keepsite_name
        status_name
        status_code
      }
    }
    getCustLendfile {
      items {
        len_id
        hold_id
        marc_id
        title
        barcode
        callnumber
        returndate
        overdueday
        continuedate
        continuenum
        iscancontinue
        status_name
        status_code
        reservepeoplenum
      }
    }
  }
`;

const M_PROCCONTINUE = gql`
  mutation procContinue($barcode: String) {
    procContinue(Input: { barcode: $barcode }) {
      success
      message
    }
  }
`;

const M_PROCTAKE = gql`
  mutation procTake($book_id: Int!) {
    procTake(Input: { book_id: $book_id }) {
      success
      message
    }
  }
`;

const M_PROCIN = gql`
  mutation procIn($book_id: Int!, $locker_detail_id: Int!) {
    procIn(Input: { book_id: $book_id, locker_detail_id: $locker_detail_id }) {
      success
      message
    }
  }
`;

const M_PROCOUT = gql`
  mutation procOut($book_id: Int!, $locker_detail_id: Int!) {
    procOut(Input: { book_id: $book_id, locker_detail_id: $locker_detail_id }) {
      success
      message
    }
  }
`;

const QL_LOCKERINFO = gql`
  query getLockerInfo($lockerId: Int!) {
    getLockerInfo(Input: { locker_id: $lockerId }) {
      success
      locker {
        id
        name
        locker_tier
        locker_column
      }
      locker_detail {
        id
        locker_id
        name
        code
        status
      }
      items {
        id
        url
        title
        author
        status
        publisher
        pub_date
        edition
        price
        isbn
        photo
        intro
        locker_id
        locker_detail_id
      }
    }
  }
`;

const M_SETLED = gql`
  mutation setLED($command: String!) {
    setLED(Input: { command: $command }) {
      success
      message
    }
  }
`;

const M_OPENDOOR = gql`
  mutation openDoor($door_id: Int!) {
    openDoor(Input: { door_id: $door_id }) {
      success
      message
      door_id
      door_status
    }
  }
`;

const QL_DOORSTATUS = gql`
  query getDoorStatus($door_id: Int!) {
    getDoorStatus(Input: { door_id: $door_id }) {
      success
      message
      door_id
      door_status
    }
  }
`;

const QL_BARCODECARDID = gql`
  query getBarcodeCardID($timeout: Int!) {
    getBarcodeCardID(Input: { timeout: $timeout }) {
      success
      message
      code
      number
      barcode
    }
  }
`;

const M_CLOSEBARCODECARDID = gql`
  mutation closeBarcodeCardID {
    closeBarcodeCardID {
      success
      message
    }
  }
`;

export async function login(params?: LoginForm): Promise<LoginResult> {
  return client
    .mutate({
      mutation: M_LOGIN,
      variables: {
        form: {
          code: params?.code,
          pass: params?.pass,
        },
      },
      fetchPolicy: "no-cache",
    })
    .then(async (res) => {
      return res.data.login;
    })
    .catch((err) => {
      console.error(err);
    });
}

export async function loginPrivate(params?: LoginForm): Promise<LoginResult> {
  return client
    .mutate({
      mutation: M_LOGINPRIVATE,
      variables: {
        form: {
          code: params?.code,
        },
      },
      fetchPolicy: "no-cache",
    })
    .then(async (res) => {
      return res.data.loginPrivate;
    })
    .catch((err) => {
      console.error(err);
    });
}

export async function getBookISBN(isbn: string): Promise<SvBook> {
  return client
    .query({
      query: QL_BOOKISBN,
      variables: {
        form: {
          isbn: isbn,
        },
      },
      fetchPolicy: "no-cache",
    })
    .then(async (res) => {
      return res.data.getBook.data?.[0];
    })
    .catch((err) => {
      console.error(err);
    });
}

export async function getCustItem(): Promise<any> {
  return client
    .query({
      query: QL_CUSTITEM,
      fetchPolicy: "no-cache",
    })
    .then(async (res) => {
      return res.data;
    })
    .catch((err) => {
      console.error(err);
    });
}

export async function procContinue(barcode: string): Promise<any> {
  return client
    .mutate({
      mutation: M_PROCCONTINUE,
      variables: {
        barcode: barcode,
      },
      fetchPolicy: "no-cache",
    })
    .then(async (res) => {
      return res.data.procContinue;
    })
    .catch((err) => {
      console.error(err);
    });
}

export async function procIn(book_id: number, locker_detail_id: number) {
  return client
    .mutate({
      mutation: M_PROCIN,
      variables: { book_id: book_id, locker_detail_id: locker_detail_id },
      fetchPolicy: "no-cache",
    })
    .then(async (result) => {
      return result.data.procIn;
    });
}

export async function procOut(book_id: number, locker_detail_id: number) {
  return client
    .mutate({
      mutation: M_PROCOUT,
      variables: { book_id: book_id, locker_detail_id: locker_detail_id },
      fetchPolicy: "no-cache",
    })
    .then(async (result) => {
      return result.data.procOut;
    });
}

export async function procTake(book_id: number) {
  return client
    .mutate({
      mutation: M_PROCTAKE,
      variables: { book_id: book_id },
      fetchPolicy: "no-cache",
    })
    .then(async (result) => {
      return result.data.procTake;
    });
}

export async function getLockerInfo() {
  return client
    .query({
      query: QL_LOCKERINFO,
      variables: { lockerId: 1 },
      fetchPolicy: "no-cache",
    })
    .then(async (result) => {
      return result.data.getLockerInfo;
    });
}

export async function openLED() {
  return driver
    .mutate({
      mutation: M_SETLED,
      variables: { command: "111" },
      fetchPolicy: "no-cache",
    })
    .then(async (result) => {
      return result.data.setLED;
    });
}

export async function closeLED() {
  return driver
    .mutate({
      mutation: M_SETLED,
      variables: { command: "000" },
      fetchPolicy: "no-cache",
    })
    .then(async (result) => {
      return result.data.setLED;
    });
}

export async function openDoor(id: number) {
  return driver
    .mutate({
      mutation: M_OPENDOOR,
      variables: { door_id: id },
      fetchPolicy: "no-cache",
    })
    .then(async (result) => {
      return driver
        .query({
          query: QL_DOORSTATUS,
          variables: { door_id: id },
          fetchPolicy: "no-cache",
        })
        .then(async (result) => {
          if (result.data.getDoorStatus.door_status === 1) {
            return true;
          } else {
            return false;
          }
        });
    });
}

export async function closeDoor(id: number) {
  return driver
    .query({
      query: QL_DOORSTATUS,
      variables: { door_id: id },
      fetchPolicy: "no-cache",
    })
    .then(async (result) => {
      if (result.data.getDoorStatus.door_status === 2) {
        return true;
      } else {
        return false;
      }
    });
}

export async function openReader(callback: any, rollback: any) {
  return driver
    .query({
      query: QL_BARCODECARDID,
      variables: { timeout: 70 },
      fetchPolicy: "no-cache",
    })
    .then(async (res) => {
      // 向下相容用 塞入cardNo
      let cardNo = "";
      if (res.data.getBarcodeCardID.code !== "") {
        if (res.data.getBarcodeCardID.number !== "") {
          cardNo = res.data.getBarcodeCardID.number;
        } else {
          cardNo = res.data.getBarcodeCardID.code;
        }
      }
      if (res.data.getBarcodeCardID.barcode !== "") {
        cardNo = res.data.getBarcodeCardID.barcode;
      }
      callback(cardNo);
    })
    .catch((error) => {
      rollback();
    });
}

export async function closeReader() {
  return driver.mutate({
    mutation: M_CLOSEBARCODECARDID,
    fetchPolicy: "no-cache",
  });
}
